import * as React from "react";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import { styled} from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";

import Toolbar from "@mui/material/Toolbar";

 
const FetchApi = () => {
  const [search, setsearch] = useState("Kesari");
  const [load, setload] = useState([]);
  const extract = useRef("");
  var i = 1;
  useEffect(() => {
    const fetchA=()=>{
      const url = `https://itunes.apple.com/search?term=${search}`;
      const promise = axios.get(url);
      promise
        .then((data) => {
          setload(data?.data?.results.slice(0,15));
        })
        .catch((err) => {
          console.log(err);
        });
    }
    
    fetchA();
  }, [search]);
  
  
  
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
window.addEventListener('keydown',(event)=>{
   if(event.code==="Enter"){
    setsearch(event.target.value);
    
   }
})
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
         
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: "5", sm: "block" } }}
            >
              Music Adda
            </Typography>
            <input ref={extract} type="text"style={{width:"30vw"}} className="form-control" />
            &nbsp;
            <button  className="btn btn-primary" onClick={()=>{
                
                setsearch(extract.current.value);
            }}>Search</button>
           
          </Toolbar>
          
        </AppBar>
      </Box>
      <br />
      <div className="container">
        {load?.map((e) => {
          return (
            <span key={i++}>
              
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <Item>
                      
                      <img
                        style={{ borderRadius: "20px" }}
                        src={e.artworkUrl100}
                        alt="Img"
                      />
                      <p style={{fontStyle:"italic",fontWeight:"bold"}}>{e.collectionName}</p>
                      <audio
                        style={{ width: "80vw" }}
                        controls
                        
                        src={e.previewUrl}
                      ></audio>
                    </Item>
                  </Grid>
                </Grid>
              </Box>
            </span>
          );
        })}
      </div>
    </>
  );
};

export default FetchApi;
